export default __webpack_public_path__ + "static/media/auth-bg.599a0c01.png";